
  <template>
  <v-container id="tpvrest" tag="section">
    <base-v-component heading="Reservas restaurante " />
    <base-material-card
      color="indigo"
      icon="mdi-calendar-clock"
      inline
      class="px-5 py-3"
    >
      <!-- <v-toolbar flat color="white">
        <v-btn
          :disabled="disabledGuardarGeneral"
          color="secondary"
          :loading="loadingForm"
          dark
          class="mb-2"
          @click.stop="save()"
          >Guardar</v-btn
        >
        <v-spacer />
      </v-toolbar> -->
      <v-tabs
        vertical
        background-color="deep-purple accent-4"
        center-active
        dark
        v-model="tab"
      >
        <v-tab key="configuracion">Configuracion</v-tab>
        <v-tab key="calendario">Calendario</v-tab>
        <v-tab key="reservas">Reservas</v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item key="configuracion">
            <v-toolbar flat
              ><v-toolbar-title>Configuración</v-toolbar-title>
              <v-spacer />
              <v-btn
                color="primary"
                @click="saveConfiguracion"
                :loading="saveConfiguracionLoading"
                >Guardar</v-btn
              ></v-toolbar
            >
            <v-container>
              <v-alert color="info"
                >Los horarios de reservas se gestionan en
                <v-btn text small @click="goHorarios">horarios</v-btn></v-alert
              >
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    label="Franjas para reservas"
                    v-model="config.franjas"
                    :items="franjas"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Antelacion"
                    messages="Antelación mínima en horas"
                    v-model="config.antelacion"
                    type="number"
                    step="1"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item key="calendario">
            <v-toolbar flat>
              <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
              >
                Hoy
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small> mdi-chevron-right </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
            </v-toolbar>
            <v-container>
              <v-sheet height="600" class="d-flex">
                <v-calendar
                  locale="es"
                  ref="calendar"
                  v-model="calendario"
                  :weekdays="weekdays"
                  type="month"
                  :events="reservasComputed"
                  event-overlap-mode="stack"
                  :event-overlap-threshold="30"
                  :event-color="getEventColor"
                  @click:event="showEvent"
                  @click:date="addEvent"
                  @change="cambioCalendario"
                  ><template v-slot:event="{ event, timed, eventSummary }">
                    <div
                      class="v-event-draggable"
                      v-html="eventSummary()"
                    ></div></template
                ></v-calendar>
              </v-sheet>
            </v-container>
          </v-tab-item>
          <v-tab-item></v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </base-material-card>
    <v-dialog v-model="nuevaReservaDialog" max-width="800px">
      <v-card>
        <v-card-title v-if="!nuevaReserva.id">Nueva reserva</v-card-title>
        <v-card-title v-else
          >Editando reserva de {{ nuevaReserva.nombre }}</v-card-title
        >
        <v-card-text>
          <v-row>
            <!-- <v-col cols="12" md="8">
              <v-select
                label="Seleccione horario"
                :items="rangosSeleccionHorarioItems"
                v-model="nuevaReserva.seleccionRango"
              />
            </v-col> -->
            <v-col cols="12" md="4">
              <v-text-field label="Día" readonly v-model="nuevaReserva.dia" />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="6">
              <v-time-picker
                v-model="nuevaReserva.inicio"
                readonly
                format="24hr" /></v-col
            ><v-col cols="12" md="6">
              <v-time-picker v-model="nuevaReserva.fin" readonly format="24hr"
            /></v-col>
            <v-col cols="12" md="8">
              <v-text-field v-model="nuevaReserva.nombre" label="Nombre" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="nuevaReserva.telefono" label="Teléfono" />
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field v-model="nuevaReserva.email" label="Email" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="nuevaReserva.comensales"
                label="Comensales"
                type="Number"
                step="1"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="!nuevaReserva.confirmado"
            color="info"
            @click="confirmarReserva"
            class="mx-3"
            :loading="saveReservaLoading"
            >Confirmar</v-btn
          >
          <v-btn
            color="primary"
            @click="saveReserva"
            :loading="saveReservaLoading"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { restSinNegocio } from "@/utils/restaurantes.utils.js";
import moment from "moment-timezone";

export default {
  data() {
    return {
      tab: 1,
      config: {
        franjas: null,
        antelacion: null,
      },

      saveConfiguracionLoading: false,
      calendario: "",
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      mode: "stack",
      colors: ["blue", "indigo", "deep-purple"],
      nuevaReservaDialog: false,
      nuevaReserva: {
        id: null,
        dia: "",
        inicio: "",
        fin: "",
        nombre: "",
        comensales: "",
        email: "",
        telefono: "",
        // seleccionRango: null,
        reservaInicioUnix: "",
      },
      saveReservaLoading: false,
      reservas: [],
      dragEvent: null,
      dragStart: null,
      createEvent: null,
      createStart: null,
    };
  },
  watch: {
    nuevaReservaDialog(v) {
      if (!v) {
        this.nuevaReserva = {
          telefono: "",
          id: null,
          inicio: "",
          fin: "",
          nombre: "",
          comensales: "",
          email: "",
          // seleccionRango: null,
          dia: "",
          reservaInicioUnix: "",
        };
      } else {
        this.nuevaReserva.dia = this.calendario;
      }
    },
    // "nuevaReserva.seleccionRango"(v) {
    //   if (v && v.length === 2) {
    //     this.reservaInicioUnix = v[0];
    //     this.nuevaReserva.inicio = moment
    //       .unix(v[0])
    //       .tz("Europe/Madrid")
    //       .format("HH:mm");
    //     this.nuevaReserva.fin = moment
    //       .unix(v[1])
    //       .tz("Europe/Madrid")
    //       .format("HH:mm");
    //   }
    // },
  },
  computed: {
    // emailsReservasComputados: {
    //   get() {
    //     return this.config.emails ? this.config.emails.toString() : "";
    //   },
    //   set(val) {
    //     var expresionRegular = /\s*,\s*/;
    //     this.config.emails = val.split(expresionRegular);
    //   },
    // },
    reservasComputed() {
      return this.reservas.map((res) => {
        return {
          name:
            moment.unix(res.reservaInicioUnix).format("HH:mm") +
            " " +
            (res.nombre
              ? res.nombre
              : res.telefono
              ? res.telefono
              : res.email
              ? res.email
              : "Sin más info"),
          start: moment.unix(res.reservaInicioUnix).toDate(),
          color: !!res.confirmado ? "primary" : "warning",
          datos: res,
        };
      });
    },

    rangosSeleccionHorarioItemsOLD() {
      //no se usa
      var res = [];

      //   console.log(this.restGest);
      let diaSemana = moment(this.calendario, "YYYY-MM-DD").isoWeekday() - 1;
      let horariosSemana = this.restGest.horarios.semana;
      let tipos = this.restGest.horarios.tipos;

      if (
        horariosSemana &&
        horariosSemana[diaSemana] &&
        horariosSemana[diaSemana].reserva
      ) {
        let fHorario = tipos.find(
          (t) => t.nombre == horariosSemana[diaSemana].reserva
        );
        if (fHorario) {
          fHorario.rangos.forEach((h) => {
            var finRango = moment
              .tz(
                this.calendario + " " + h.fin,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
              )
              .unix();
            let currentHorario = moment
              .tz(
                this.calendario + " " + h.inicio,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
              )
              .unix();
            let currentHorarioFin = moment
              .tz(
                this.calendario + " " + h.inicio,
                "YYYY-MM-DD HH:mm",
                "Europe/Madrid"
              )
              .add(this.config.franjas, "minutes")
              .unix();
            while (currentHorario < finRango) {
              res.push({
                text:
                  moment
                    .unix(currentHorario)
                    .tz("Europe/Madrid")
                    .format("HH:mm") +
                  " - " +
                  moment
                    .unix(currentHorarioFin)
                    .tz("Europe/Madrid")
                    .format("HH:mm"),
                value: [currentHorario, currentHorarioFin],
              });
              currentHorario = currentHorarioFin;
              currentHorarioFin = moment
                .unix(currentHorarioFin)
                .add(this.config.franjas, "minutes")
                .unix();
            }
          });
        }
      }
      return res;
    },

    franjas() {
      return [
        {
          text: "10 minutos",
          value: 10,
        },
        {
          text: "15 minutos",
          value: 15,
        },
        {
          text: "20 minutos",
          value: 20,
        },
        {
          text: "25 minutos",
          value: 25,
        },
        {
          text: "30 minutos",
          value: 30,
        },
        {
          text: "45 minutos",
          value: 45,
        },
        {
          text: "60 minutos",
          value: 60,
        },
      ];
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
      restGest: "app/restGestObj",
    }),
  },
  methods: {
    confirmarReserva() {
      this.saveReservaLoading = true;
      this.$store
        .dispatch("restaurantes/confirmarReserva", this.nuevaReserva)
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Reserva confirmada",
          });
          this.nuevaReservaDialog = false;
          this.getReservas();
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al confirmar la reserva: " + e,
          });
        })
        .finally(() => (this.saveReservaLoading = false));
    },
    cambioCalendario() {
      this.getReservas();
    },
    saveReserva() {
      this.nuevaReserva.reservaInicioUnix = this.nuevaReserva.seleccionRango[0];
      this.saveReservaLoading = true;
      this.$store
        .dispatch("restaurantes/saveReserva", this.nuevaReserva)
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Reserva guardada",
          });
          this.nuevaReservaDialog = false;
          this.getReservas();
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la reserva: " + e,
          });
        })
        .finally(() => (this.saveReservaLoading = false));
    },
    getReservas() {
      var fechasBuscar;
      if (!this.calendario || this.calendario.trim().length === 0) {
        fechasBuscar = {
          inicio: moment.tz("Europe/Madrid").startOf("month").unix(),
          fin: moment.tz("Europe/Madrid").endOf("month").unix(),
        };
      } else {
        fechasBuscar = {
          inicio: moment
            .tz(this.calendario, "YYYY-MM-DD", "Europe/Madrid")
            .startOf("month")
            .unix(),
          fin: moment
            .tz(this.calendario, "YYYY-MM-DD", "Europe/Madrid")
            .endOf("month")
            .unix(),
        };
      }

      this.$store
        .dispatch("restaurantes/getReservas", fechasBuscar)
        .then((r) => {
          this.reservas = r;
          // this.$store.commit("snackbar/setMensajeSuccess", {
          //   msj: "Reserva guardada",
          // });
          // this.nuevaReservaDialog = false;
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la reserva: " + e,
          });
        });
    },
    showEvent(item) {
      this.nuevaReserva = { ...item.event.datos };
      this.nuevaReservaDialog = true;
    },
    addEvent() {
      this.nuevaReservaDialog = true;
    },
    setToday() {
      this.calendario = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    goHorarios() {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(this.restGest) +
        "/horarios";
      this.$router.push(str);
    },
    saveConfiguracion() {
      this.saveConfiguracionLoading = true;
      this.$store
        .dispatch("restaurantes/saveConfiguracionReservas", this.config)
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Configuración guardada",
          });
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la configuración: " + e,
          });
        })
        .finally(() => (this.saveConfiguracionLoading = false));
    },

    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
  mounted() {
    // this.calendario = moment.tz("Europe/Madrid").format("YYYY-MM-DD");
    this.$store.dispatch("restaurantes/getConfiguracionReservas").then((r) => {
      if (!!r) {
        this.config = r;
      }
    });
  },
};
</script>

<style>
</style>